(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.ukdemographic === "undefined") {
        jQuery.extend(sm.portal.vm, { ukdemographic: {} });
    }

    function InitializeLocalizationProperties(demo){
        //Ethnic Origins is a single select in UK portal.
        demo.EthnicOriginIDUK = ko.validatedObservable();
    }

    function ShowForeignBornDetails(demographic)
    {
        var showForeignBornDetails = false;

        if (!sm.portal.utility.isNullOrEmpty(demographic.CitizenshipID()) && !sm.portal.utility.isNullOrEmpty(demographic.SystemCountryID())) {
            if (demographic.CitizenshipID().toString() != demographic.SystemCountryID().toString()) {

                if (IsUKCountry(demographic.SystemCountryID().toString(), demographic)) {
                    showForeignBornDetails = !IsUKCountry(demographic.CitizenshipID().toString(),demographic);
                } else {
                    showForeignBornDetails = true;
                }
            }
        }


        return showForeignBornDetails;
    }

    function IsUKCountry (id, demographic) {
        var match = false;
        ko.utils.arrayForEach(demographic.UKCountries(), function (ukCountry) {
            if (ukCountry.ID().toString() === id.toString()) {
                match = true;
            }
        });

        return match;
    }

    function LoadModel(demographic, container)
    {
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        demographic.Genders = smapi.access.loadListItemModels(container.Payload.ListData.Gender, demographic.Genders);
        demographic.GenderIdentities = smapi.access.loadListItemModels(container.Payload.ListData.GenderIdentity, demographic.GenderIdentities);
        demographic.SexualOrientations = smapi.access.loadListItemModels(container.Payload.ListData.SexualOrientation, demographic.SexualOrientations);
        demographic.ReligionOptions = smapi.access.loadListItemModels(container.Payload.ListData.ReligionOptions, demographic.ReligionOptions);
        demographic.UKCountries = smapi.access.loadListItemModels(container.Payload.ListData.UKCountries, demographic.UKCountries);

        
        if (container.Payload.Demographic != null) {
            demographic.GenderID(container.Payload.Demographic.GenderID);
            demographic.GenderIdentityID(container.Payload.Demographic.GenderIdentityID);
            demographic.SexualOrientationID(container.Payload.Demographic.SexualOrientationID);
            demographic.DualNationalityID(container.Payload.Demographic.DualNationalityID);
            demographic.ReligionID(container.Payload.Demographic.ReligionID);
            demographic.RequireVisa(container.Payload.Demographic.RequireVisa.toString());
            demographic.VisaNumber(container.Payload.Demographic.VisaNumber);

            var data = {
                demographic : demographic,
                container : container
            }
            sm.portal.vm.custom.callCustomization('LoadDemographicData', data,
                function () {
                    if (container.Payload.Demographic.DateOfEntryToUK != null && container.Payload.Demographic.DateOfEntryToUK != undefined) {
                        demographic.DateOfEntryToUK(moment(container.Payload.Demographic.DateOfEntryToUK, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat));
                    } else {
                        demographic.DateOfEntryToUK(container.Payload.Demographic.DateOfEntryToUK);
                    }                            
                }
            );

            demographic.EthnicOriginIDUK(container.Payload.Demographic.EthnicOriginIDs[0]);
            //This is needed to wipe the list out again. 

            var shouldClearEthnicIDs= sm.portal.vm.custom.callCustomization('EthnicOriginArr');
            
            if(sm.portal.utility.isNullOrEmpty(shouldClearEthnicIDs)){
                demographic.EthnicOriginIDs = ko.observableArray();
            }

            if (container.Payload.Demographic.PassportExpiration != null && container.Payload.Demographic.PassportExpiration != undefined) {
                demographic.PassportExpiration(moment(container.Payload.Demographic.PassportExpiration, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat));
            } else {
                demographic.PassportExpiration(container.Payload.Demographic.PassportExpiration);
            }
            demographic.PassportIssuePlace(container.Payload.Demographic.PassportIssuePlace);
            demographic.CriminalConviction(container.Payload.Demographic.CriminalConviction);
        }

    }

    function AnythingPopulated (demographic) 
    {
        if (!sm.portal.utility.isNullOrEmpty(demographic.EthnicOriginIDUK())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.DualNationalityID())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.ReligionID())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.RequireVisa())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.DateOfEntryToUK())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.PassportExpiration())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.PassportIssuePlace())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.VisaNumber())) return true;
        if (!sm.portal.utility.isNullOrEmpty(demographic.CriminalConviction())) return true;
    }
    function ExtractATO(demographic, demoMain){
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        var visaExpirationDate = moment(demographic.VisaExpirationDate(), dateFormat).format('YYYY-MM-DD');
        var dateOfServiceStart = moment(demographic.DateOfServiceStart(), dateFormat).format('YYYY-MM-DD');
        var dateOfServiceEnd = moment(demographic.DateOfServiceEnd(), dateFormat).format('YYYY-MM-DD');
        var dateOfEntryToUK = moment(demographic.DateOfEntryToUK(), dateFormat).format('YYYY-MM-DD');
        var passportExpiration = moment(demographic.PassportExpiration(), dateFormat).format('YYYY-MM-DD');

        demoMain.AlienIDNumber = demographic.AlienIDNumber;
        demoMain.ReligionID = demographic.ReligionID;
        demoMain.CriminalConviction = demographic.CriminalConviction;
        demoMain.GenderID = demographic.GenderID;
        //demoMain.EthnicOrigins[0] = demographic.EthnicOriginIDUK();

        if (!sm.portal.utility.isNullOrEmpty(demographic.CitizenshipID()) && demographic.CitizenshipID() > 0) {
            var citizenship = demoMain.Citizenships()[0];
            
            citizenship.PassportNumber = demographic.PassportNumber();
            citizenship.PermanentResidentStatusID = demographic.PermanentResidentFlagID();
            citizenship.VisaTypeID = demographic.VisaTypeID();
            citizenship.VisaExpirationDate = moment(demographic.VisaExpirationDate(), dateFormat).format('YYYY-MM-DD');
            citizenship.RequireVisa = demographic.RequireVisa;
            citizenship.VisaExpirationDate = visaExpirationDate;
            citizenship.DateOfEntryToUK = dateOfEntryToUK;
            citizenship.PassportExpiration = passportExpiration;
            citizenship.PassportIssuePlace = demographic.PassportIssuePlace;
            citizenship.VisaNumber = demographic.VisaNumber;
            citizenship.IsPrimary = true;

            if (!demographic.RequireVisa())
                sm.portal.vm.custom.callCustomization('UpdateCitizenshipData', citizenship);

        }

        if (!sm.portal.utility.isNullOrEmpty(demographic.DualNationalityID()) && demographic.DualNationalityID() > 0) {

            var dualNationality = new smapi.community.CitizenshipModel({
                CountryID: demographic.DualNationalityID(),
                IsPrimary: false,
                ID: demographic.DualNationalityItemID(),
                GID: demographic.DualNationalityItemGID()
            });
            demoMain.Citizenships().push(dualNationality);
        }
    }

    jQuery.extend(true, sm.portal.vm.ukdemographic, {
        ExtractATO: ExtractATO,
        AnythingPopulated : AnythingPopulated,
        LoadModel : LoadModel,
        ShowForeignBornDetails : ShowForeignBornDetails,
        InitializeLocalizationProperties : InitializeLocalizationProperties

    });

})(jQuery);